import { render, staticRenderFns } from "./PlayersLoader.vue?vue&type=template&id=c6cc4bca&"
import script from "./PlayersLoader.vue?vue&type=script&lang=js&"
export * from "./PlayersLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports